const ProductPrice = ({ discountPrice, price, margin = true, preset = 'standard' }) => {
  if (!price) return null

  // Render regular price only
  if (!discountPrice || discountPrice === price) {
    return (
      <div className={`product-price product-price--${margin ? 'margin' : 'no-margin'}`} data-testid="product-price-outer">
        <div className={`product-price product-price-final--${preset}`} data-testid="product-price-inner">
          <span data-testid="product-price-value">{`$${parseFloat(price).toFixed(2)}`}</span>
        </div>
      </div>
    )
  }

  return (
    <div className={`product-price product-price--${margin ? 'margin' : 'no-margin'}`} data-testid="product-price-outer">
      <div className={`product-price-final product-price-final--discounted product-price-final--${preset}`} data-testid="product-price-inner">
        <span data-testid="product-price-value">{`$${parseFloat(discountPrice).toFixed(2)}`}</span>
      </div>
      <span className={`product-price-original product-price-original--${preset}`}>{`$${parseFloat(price).toFixed(2)}`}</span>
    </div>
  )
}

export default ProductPrice
